export default "__VITE_ASSET__9ab83152__"